import { Link, useNavigate } from "react-router-dom";
import { Briefcase, LayoutDashboard } from "lucide-react";
import { Button } from "@/components/ui/button";
import { portalPath, useAuth } from "@/context/AuthContext";

export const PublicNavbar = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 w-full border-b border-border bg-white/80 backdrop-blur-md">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="navbar-logo" className="flex items-center gap-2">
          <span className="h-9 w-9 rounded-lg bg-primary flex items-center justify-center">
            <Briefcase className="h-5 w-5 text-white" />
          </span>
          <span className="font-heading font-semibold text-lg tracking-tight">
            Udhyog<span className="text-primary">Tech</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-6 text-sm font-medium text-muted-foreground">
          <Link to="/" data-testid="navbar-home-link" className="hover:text-foreground transition-colors">Home</Link>
          <Link to="/jobs" data-testid="navbar-jobs-link" className="hover:text-foreground transition-colors">Find Jobs</Link>
          <Link
            to={user?.role === "member" ? "/member" : "/login"}
            data-testid="navbar-track-link"
            className="hover:text-foreground transition-colors"
          >
            Track My Application
          </Link>
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <Button data-testid="navbar-dashboard-button" onClick={() => navigate(portalPath(user.role))} className="rounded-lg">
              <LayoutDashboard className="h-4 w-4 mr-2" /> Dashboard
            </Button>
          ) : (
            <Button data-testid="navbar-login-button" variant="outline" onClick={() => navigate("/login")} className="rounded-lg bg-white">
              Login
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};
